import { render, staticRenderFns } from "./PrepareTest.vue?vue&type=template&id=184c4c7c&scoped=true&"
import script from "./PrepareTest.vue?vue&type=script&lang=js&"
export * from "./PrepareTest.vue?vue&type=script&lang=js&"
import style0 from "./PrepareTest.vue?vue&type=style&index=0&id=184c4c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c4c7c",
  null
  
)

export default component.exports